<script>
  export let image;
  export let imageAlt = "Popup Image";
  export let title;
  export let content;
  export let videoUrl;
  export let gallery;
  export let handleVideoLoad;

  import CloseButton from "./CloseButton.svelte";
  import PopupGallery from "./PopupGallery.svelte";
  import { fly, fade } from "svelte/transition";
  import { focusTrap } from "./utils.js";
  import { tourFunctions } from "../tour-functions";
  import { tick } from "svelte";
  export let ariaLabel = `Popup: ${title}`;

  let popupModal;
  let scrollContainer;

  $: if (visible) focusPopup();

  // Create a focus trap
  async function focusPopup() {
    await tick();
    scrollContainer.focus();
  }

  function openGallery() {
    const galleryElem = document.getElementById("popup-gallery");
    new PopupGallery({
      target: galleryElem,
      props: { gallery: gallery, close: closePopup },
    });
    focusTrap(galleryElem);
  }

  let visible = true;
  function closePopup() {
    visible = false;
    tourFunctions.focus();
  }

  function getPopupTextColor() {
    // get --popup-text-color from the root element
    const rootStyles = getComputedStyle(document.documentElement);
    const popupTextColor = rootStyles.getPropertyValue("--popup-text-color");
    return popupTextColor || "#000";
  }
</script>

{#if visible}
  <div id="popup-gallery"></div>

  <div
    bind:this={popupModal}
    class="popup-modal"
    class:has-image={image ? true : false}
    use:focusTrap
  >
    <div class="popup-area">
      <div class="popup-window-wrap">
        <div class="popup-window" transition:fly={{ y: 800, duration: 500 }}>
          <div class="popup-content">
            <div class="popup">
              <CloseButton close={closePopup} color={getPopupTextColor()} />
              {#if image}
                <div class="image column">
                  <img src={image} alt={imageAlt} class="popup-image" />
                  <div class="items">
                    {#if gallery}
                      <button
                        class="gallery item"
                        tabindex="0"
                        on:click={openGallery}
                        aria-label="Open Gallery"
                      >
                        <!-- <img
                          src="./images/popup_gallery_button.png"
                          alt="Open Gallery"
                        /> -->
                        <div class="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 197.04 197.04"
                            ><circle
                              cx="98.52"
                              cy="98.52"
                              r="88.52"
                              style="fill:none;stroke:var(--popup-text-color);stroke-miterlimit:10;stroke-width:15px"
                            /><path
                              d="M145,67.57H127.41l-2-6.64a5.17,5.17,0,0,0-5-3.68H79.66a5.15,5.15,0,0,0-4.94,3.68l-2,6.64H52.09a5.16,5.16,0,0,0-5.16,5.15v61.91a5.16,5.16,0,0,0,5.16,5.16H145a5.16,5.16,0,0,0,5.16-5.16V72.72A5.16,5.16,0,0,0,145,67.57ZM98.52,119.15a20.64,20.64,0,1,1,20.63-20.63A20.64,20.64,0,0,1,98.52,119.15Z"
                              style="fill:var(--popup-text-color);"
                            /></svg
                          >
                        </div>
                        <span>Photos</span>
                      </button>
                    {/if}
                    {#if videoUrl}
                      <button
                        class="video item"
                        tabindex="0"
                        on:click={handleVideoLoad}
                        aria-label="Play Video"
                      >
                        <!-- <img
                          src="./images/popup_video_button.png"
                          alt="Play Video"
                        /> -->
                        <div class="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 197.04 197.04"
                            ><path
                              d="M61,98.14c0-13.83,0-27.65,0-41.47,0-9.45,6.43-13.08,14.69-8.26q35.57,20.78,71,41.69c8.17,4.82,8.16,11.62,0,16.44Q111.52,127.33,76.16,148c-8.68,5.07-15.09,1.26-15.11-8.88C61,125.45,61,111.79,61,98.14Z"
                              style="fill:var(--popup-text-color)"
                            /><circle
                              cx="98.52"
                              cy="98.52"
                              r="88.52"
                              style="fill:none;stroke:var(--popup-text-color);stroke-miterlimit:10;stroke-width:15px"
                            /></svg
                          >
                        </div>
                        <span>Video</span>
                      </button>
                    {/if}
                  </div>
                </div>
              {/if}

              <div class="content column">
                <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
                <div
                  class="content-inner"
                  role="dialog"
                  aria-label={ariaLabel}
                  tabindex="0"
                  bind:this={scrollContainer}
                >
                  <h2 class="title">{@html title}</h2>
                  {@html content}
                  {#if !image}
                    <div class="items">
                      {#if gallery}<button
                          class="gallery item"
                          tabindex="0"
                          on:click={openGallery}
                        >
                          <img
                            src="./images/popup_gallery_button.png"
                            alt="Open Gallery"
                          /><span>Photos</span>
                        </button>{/if}
                      {#if videoUrl}<button
                          class="video item"
                          tabindex="0"
                          on:click={handleVideoLoad}
                        >
                          <img
                            src="./images/popup_video_button.png"
                            alt="Play Video"
                          /><span>Video</span>
                        </button>{/if}
                    </div>
                    <!-- END .items -->
                  {/if}
                </div>
                <!-- end content-inner -->
              </div>
              <!-- end content -->
            </div>
          </div>
        </div>
      </div>
      <div
        class="popup-bg"
        on:click={closePopup}
        transition:fade={{ duration: 500 }}
      ></div>
    </div>
  </div>
{/if}

<style>
  .popup {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .column {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
    height: 100%;
  }

  .image {
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  .title {
    margin: 2rem 0;
    margin-bottom: 0;
    margin-right: 28px;
    font-family: var(--font-heading), sans-serif;
    font-size: 2rem;
    line-height: 1;
  }

  .content {
    justify-content: center;
    font-family: var(--font-body), sans-serif;
    line-height: 1.5;
  }

  .content-inner {
    padding: 2rem;
    padding-top: 0;
    overflow-y: scroll;
    max-height: 90vh;
  }

  .content-inner:focus {
    outline: none;
  }

  .items {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 5%;
    justify-content: center;
  }

  .item {
    appearance: none;
    border: none;
    text-align: inherit;
    color: inherit;

    cursor: pointer;
    background: rgba(var(--popup-bg-color-rgb), 0.85);
    border-radius: 5px;
    margin: 5px;
    padding: 0.5rem 2rem;
    font-size: 1.5rem;
    display: flex;
    flex-direction: row;
    flex-basis: 100%;
    flex: 0;
    height: 100%;
    font-family: var(--font-heading), sans-serif;
    font-weight: 300;
    box-shadow: 1px 2px 2px #00000040;
    justify-content: center;
    align-items: center;
    border: 2px solid transparent;
  }

  .item:hover {
    border: 2px solid var(--popup-text-color);
  }

  .item img,
  .item svg {
    width: 1em;
    height: 1em;
  }

  .icon {
    margin-inline: 0.25em;
    margin-top: 0.15em;
  }

  :global(.popup .content-inner a) {
    color: var(--popup-text-color);
    font-weight: 700;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--popup-text-color);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--popup-text-color);
  }

  .popup-area {
    position: fixed;
    z-index: 2001;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100vw;
    height: 100vh;
  }

  .popup-bg {
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.66);
  }

  .popup-window {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    max-width: 75%;
    max-height: 100%;
  }

  .popup-window-wrap {
    position: relative;
    margin: 2rem;
    max-height: 100%;
    box-sizing: border-box;
  }

  .popup-window {
    position: relative;
    width: 40rem;
    max-width: 100%;
    max-height: 100%;
    margin: 2rem auto;
    color: black;
    border-radius: 10px;
    background: var(--popup-bg-color);
    color: var(--popup-text-color);
    width: 50%;
    overflow: hidden;
  }

  .popup-modal.has-image .popup-window {
    padding-bottom: 45%;
    width: 90%;
  }

  .popup-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .popup-content {
    border-radius: 5px;
    padding: 0;
    height: 100%;
    width: 100%;
  }

  .popup-modal.has-image .popup-content {
    position: absolute;
  }

  .content-inner .items {
    position: static;
    padding: 0;
  }
  .content-inner .item {
    background: #fff;
    color: #000;
  }

  .content-inner .item img {
    filter: invert(1);
  }

  @media only screen and (max-width: 600px) {
    .popup-area {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;

      width: 90%;
      height: 90%;
    }

    .popup-window-wrap,
    .popup-window {
      width: 100% !important;
      height: auto;
      margin: 0 !important;
      padding: 0 !important;
    }

    .has-image .popup-window-wrap,
    .has-image .popup-window {
      height: 100% !important;
    }

    .column {
      height: 100%;
      width: 100%;
      flex: none;
    }

    .has-image .column {
      height: 50%;
      width: 100%;
      flex: none;
    }

    .image.column {
      min-height: 40%;
      height: fit-content;
      aspect-ratio: 1/1;
    }

    .content {
      justify-content: flex-start;
    }

    .title {
      font-size: 1.75em;
    }

    .content-inner {
      font-size: 14px;
      height: 100%;
      /* somewhat arbitrary number, includes adjustments for
        padding as well as mobile browser ui elements */
      max-height: calc(100vh - 300px);
    }

    .popup-modal:not(.has-image) .content {
      margin-top: 40px;
    }

    .items {
      padding: 0.25rem;
    }

    .item {
      padding: 0.5rem 1.25rem;
    }
  }
</style>
